/**
 * 加载进度指示器模块
 * 在页面顶部显示加载进度条和百分比
 * 模型加载完成后自动淡出隐藏
 */
export class LoadingScreen {
  /** @type {HTMLElement | null} */
  #overlay = null;
  /** @type {HTMLElement | null} */
  #bar = null;
  /** @type {HTMLElement | null} */
  #text = null;

  constructor() {
    this.#create();
  }

  /** 创建 DOM 结构 */
  #create() {
    // 遮罩层
    const overlay = document.createElement('div');
    overlay.id = 'loading-overlay';
    overlay.innerHTML = `
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中 <span class="loading-percent">0%</span></div>
        <div class="loading-bar"><div class="loading-bar-fill"></div></div>
      </div>
    `;
    document.body.appendChild(overlay);

    this.#overlay = overlay;
    this.#bar = overlay.querySelector('.loading-bar-fill');
    this.#text = overlay.querySelector('.loading-percent');
  }

  /**
   * 更新进度
   * @param {number} percent - 0-100
   */
  update(percent) {
    if (!this.#bar || !this.#text) return;
    const p = Math.round(percent);
    this.#bar.style.width = `${p}%`;
    this.#text.textContent = `${p}%`;
  }

  /** 显示加载界面 */
  show() {
    if (this.#overlay) {
      this.#overlay.style.display = 'flex';
      this.#overlay.style.opacity = '1';
    }
  }

  /** 隐藏加载界面（淡出效果） */
  hide() {
    if (!this.#overlay) return;
    this.#overlay.style.transition = 'opacity 0.5s ease';
    this.#overlay.style.opacity = '0';
    setTimeout(() => {
      if (this.#overlay) {
        this.#overlay.style.display = 'none';
      }
    }, 500);
  }

  /** 显示错误信息 */
  showError(message) {
    if (!this.#overlay || !this.#text) return;
    this.#text.textContent = `加载失败: ${message}`;
    this.#text.style.color = '#ff6b6b';
  }

  /** 完全销毁（移除 DOM） */
  destroy() {
    this.#overlay?.remove();
    this.#overlay = null;
    this.#bar = null;
    this.#text = null;
  }
}
